import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={56} height={43} fill="none" {...props}>
        <Path
            fill={designSystem.colors.neutral900}
            stroke={designSystem.colors.neutral400}
            d="M38.488.5c4.799 0 8.918 1.725 11.827 5.223 2.899 3.486 4.55 8.676 4.55 15.527 0 6.878-1.652 12.068-4.552 15.548C47.404 40.289 43.286 42 38.489 42c-4.826 0-8.944-1.739-11.846-5.243-2.892-3.493-4.53-8.683-4.53-15.507 0-6.85 1.637-12.04 4.53-15.527C29.544 2.224 33.663.5 38.488.5Zm-20.518.648v40.204H7.736v-27.48l-6.502 3.445-.734.39V7.554l.27-.14 11.988-6.21.108-.056h5.104Zm20.518 8.506c-1.479 0-2.94.631-4.055 2.357-1.134 1.754-1.924 4.667-1.924 9.239 0 4.573.79 7.47 1.923 9.21 1.113 1.712 2.574 2.332 4.056 2.332 1.511 0 2.97-.622 4.077-2.33 1.125-1.74 1.904-4.638 1.904-9.212s-.779-7.486-1.906-9.24c-1.107-1.724-2.567-2.356-4.075-2.356Z"
        />
    </Svg>
);
export { SvgComponent as TenIcon };
